module.exports = __webpack_public_path__ + "img/linkedin-logo.b06afde3.svg";